// import packages
import React, {Component, useEffect, useRef, useState} from "react";
import { connect } from "react-redux";

// Import assets
import "./blog.scss"

// Import Components

// Import utils
import { getPropsFromState } from "../../../redux/mapStateToProps";
import Slider from "react-slick";
import {generateFileMediaUrl} from "../../../utils/generateMediaUrl";
import {ArrowUpRightIcon, BlogArrLeftIcon, BlogArrRightIcon} from "../../../assets/images";
import moment from "moment/moment";
import {Link, useParams} from "react-router-dom";
import {getUrlWithLocal} from "../../../utils/getUrlWithLocal";


function Blogs (props) {
    const { blogs, staticTexts,isDetail} = props
    let sliderRef = useRef(null);
    const wrapperRef = useRef(null);
    const sliderChangingRefTime = useRef(null);
    const navigateRefValue = useRef(true);
    const params = useParams();

    const [slideIndex, setSlideIndex] = useState(0);

    const nextSlide = (index) => {
        console.log(blogs?.blogList?.length,'blogs?.blogList?.length')
        setSlideIndex(slideIndex - 1 === index ? 0 : index + 1)
        if (blogs?.blogList?.length - 1 === slideIndex) {
            setSlideIndex(slideIndex)
        }
        sliderRef.slickNext();
    };

    const prevSlide = (index) => {
        setSlideIndex(index === 0 ? 0 : index - 1)
        sliderRef.slickPrev();
    };
    const slidesToShow = isDetail ? blogs?.blogList?.length - 1 : blogs?.blogList?.length

    const settings = {
        dots: false,
        arrows: false,
        autoplay:false,
        infinite:true ,
        slidesToShow: blogs?.blogList?.length > 4 ? 4 : slidesToShow,
        slidesToScroll: 1,
        ref: blogs => (sliderRef = blogs),
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: blogs?.blogList?.length > 3 ? 3 : blogs?.blogList?.length,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 1.1,
                    centerMode: true,
                    centerPadding: "40px",
                }
            },
        ]
    };

    useEffect(() => {
        if(wrapperRef.current){
            wrapperRef.current.addEventListener('wheel', (e) => {
                if (Math.abs(e.deltaY) > Math.abs(e.deltaX) - 1) {
                    return;
                }
                e.preventDefault();
                e.stopPropagation();
                if (Math.abs(e.deltaX) > 5 && Math.abs(e.deltaY) < 20) {
                    if (sliderChangingRefTime.current) {
                        const now = Date.now();
                        sliderChangingRefTime.current = now
                        if (e.deltaX < 0) {
                            sliderRef.slickPrev();
                        } else {
                            sliderRef.slickNext();
                        }
                        setTimeout((time) => {
                            // console.log('setTimeout', sliderChangingRefTime.current, time)
                            if (sliderChangingRefTime.current && time === sliderChangingRefTime.current) {
                                sliderChangingRefTime.current = null;
                                // console.log('change force')
                            }
                        }, 800, now)
                        e.returnValue = false;
                        return false;
                    }
                }

                if (Math.abs(e.deltaX) > 5) {
                    // e.preventDefault();
                    // e.returnValue = false;
                    // return false;
                }
            }, {passive: false});

        }
        return () => {
            if (wrapperRef.current) {
                wrapperRef.current?.removeEventListener('wheel', null);
            }
        };
    }, []);

    return <div className={`blogs ${isDetail ? 'detail_slider' : ''}`} ref={wrapperRef}
                onMouseDown={() => {
                    navigateRefValue.current = true;
                }}
                onMouseMove={() => {
                    navigateRefValue.current = false;
                }}>
        <div className={'blog_header'}>
            {
                isDetail ?  <div className={'blog_detail_title'}>
                    {staticTexts?.blog_detail_slider_title}
                </div> :  <div className={'blog_title'}>
                    <p>
                        {staticTexts?.blog_block_title_part} <span>{staticTexts?.blog_block_title_part_active}</span>
                    </p>
                    <p>
                        {staticTexts?.blog_block_title_second}
                    </p>
                </div>
            }
            {
                isDetail ? <div className={'arr_detail_wrapper'}>
                    {
                        slidesToShow > 3 ? <div className={'arr_left'} onClick={() => prevSlide(slideIndex)}>
                            <BlogArrLeftIcon/>
                        </div> : ''
                    }
                    {
                        slidesToShow > 3 ? <div className={'arr_right'} onClick={() => nextSlide(slideIndex)}>
                            <BlogArrRightIcon/>
                        </div> : ''
                    }
                </div> : <Link to={'/blogs'} className={'blog_see_all'}>
                    {staticTexts?.blog_see_all} <ArrowUpRightIcon/>
                </Link>
            }
        </div>
        <div className={'blog-block'}>
            <Slider {...settings}>
                {blogs?.blogList?.filter(blog => blog?.slug !== params?.slug)?.map(item => {
                    return <Link to={getUrlWithLocal(`/blogs/${item?.slug}`)} className="blog-item" key={item.id} >
                        <div className={`blog_image_block ${slidesToShow < 2 ? 'blog_img' : ''}`}>
                            <img src={generateFileMediaUrl(item?.mediaMain?.path)}
                                 className="blog-image"
                                 title={item?.mediaMain?.title ? item?.mediaMain?.title : ''}
                                 alt={item?.mediaMain?.altAttribute ? item?.mediaMain?.altAttribute : ''}/>
                        </div>
                        <div className={'blog-content'}>
                            <div className={'blog-content-title'}>
                                {item?.title}
                            </div>
                            <div className={'blog-content-info'}>
                                {
                                    item?.categories?.map(category => {
                                        return <span className={'category_block'}>#{category?.title}</span>
                                    })
                                }
                                <span>| {moment(item.data).format('MMMM DD, YYYY')}</span>
                            </div>
                        </div>
                    </Link>
                })}
            </Slider>
        </div>
        {
            isDetail ? '' : <Link to={'/blogs'} className={'bottom_blog_see_all'}>
                {staticTexts?.blog_see_all} <ArrowUpRightIcon/>
            </Link>
        }
        {
            isDetail ? '' : <div className={'blog_arr_blog'}>
                <span className={'bottom_line'}/>
                {
                    blogs?.blogList?.length > 4 ? <div className={'arr_wrapper'}>
                        <div className={'arr_left'} onClick={() => prevSlide(slideIndex)}>
                            <BlogArrLeftIcon/>
                        </div>
                        <div className={'arr_right'} onClick={() => nextSlide(slideIndex)}>
                            <BlogArrRightIcon/>
                        </div>
                    </div> : ''
                }
            </div>
        }
    </div>

}

const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'blogs',
]);

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Blogs);
